
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-24 15:15:03
-->
<template>
  <el-drawer
    :title="item.id ? '编辑组织' : '添加组织'"
    :visible.sync="visibleTwo"
    @closed="closeTwo"
   :size="width<=720?'90%':'500px'"
    :with-header="true"
    :wrapperClosable="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
       :label-width="width<=720?'120px':'110px'"
      class="demo-ruleForm"
    >
      <el-form-item label="上级组织" prop="parentId">
        <TreeSelect
          v-if="visibleTwo"
          :record="ruleForm"
          @selectpart="selectpart"
          :resData="listData"
        ></TreeSelect>
      </el-form-item>
      <el-form-item label="组织名称" prop="organizationName">
        <el-input
          v-model="ruleForm.organizationName"
          placeholder="请输入组织名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="organizationUser">
        <el-input
          v-model="ruleForm.organizationUser"
          placeholder="请输入联系人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="organizationPhone">
        <el-input
          v-model="ruleForm.organizationPhone"
          placeholder="请输入联系人方式"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" class="remard">
        <el-input
          :rows="4"
          type="textarea"
          placeholder="请输入备注"
          v-model="ruleForm.remark"
        ></el-input>
      </el-form-item>
      <el-form-item  v-if="btnShow" class="bottom">
        <div class="form-bottom">
          <el-button size="medium" @click="closeTwo">取消</el-button>
          <el-button size="medium" :loading="loading" type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import TreeSelect from "@/components/tree_selection.vue";
import { create, update } from "./organizational_structure";
import { phone } from "@/utils/reg.js";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
export default {
  data() {
    return {
      listData: [],
      disData:[],
      loading:false,
      ruleForm: {
        organizationName: undefined,
        organizationPhone: "",
        organizationUser: "",
        parentId: "",
        remark: "",
        id: "",
      },
      rules: {
        organizationName: [
          { required: true, message: "请输入组织名称", trigger: "blur" },
        ],
        organizationPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            validator: phone,
          },
        ],
        organizationUser: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        parentId: [
          { required: true, message: "请选择上级组织", trigger: "change" },
        ],
      },
      width:'',
      visibleTwo:false,
      btnShow:true,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    resData: {
      type: Array,
      default: [],
    },
    item: {
      type: Object,
      default: {},
    },
    itemAdd: {
      type: Object,
      default: {},
    },
  },
  methods: {
    close() {
       this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    closeTwo(){
       this.$refs.ruleForm.clearValidate();
      this.$emit("closeTwo");
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    selectpart(item) {
      this.ruleForm.parentId = item.value;
    },
    submit() {
      const that = this;
      this.loading = true;
       this.$refs.ruleForm.validate((valid) => {
            if(valid){
                if (this.item.id) {
                  this.ruleForm.id = this.item.id;
                  update(this.ruleForm).then((res) => {
                    if (res.code == 0) {
                      that.close();
                    }
                    this.loading = false;
                  });
                } else {
                  create(this.ruleForm).then((res) => {
                    if (res.code == 0) {
                      that.close();
                    }
                    this.loading = false;
                  });
                }
            }else{
                this.loading = false;
            }
       })
      
    },
    resetForm() {},
  },
  watch: {
    visible() {
       this.visibleTwo = this.visible;
      this.getKeyboardState()
          this.width = document.documentElement.clientWidth;
                window.onresize = () => {
                    return (() => {
                        this.width  = document.documentElement.clientWidth;
                    })();
                    };
      
      if (this.item.id) {
        this.ruleForm.parentName = this.item.parentName;
        this.ruleForm.organizationName = this.item.organizationName;
        this.ruleForm.organizationPhone = this.item.organizationPhone;
        this.ruleForm.organizationUser = this.item.organizationUser;
        this.ruleForm.parentId = this.item.parentId;
        this.ruleForm.id = this.item.id;
        this.ruleForm.remark = this.item.remark;
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
        this.listData = JSON.parse(JSON.stringify(this.resData));
      } else {
        this.ruleForm = JSON.parse(
          JSON.stringify({
            organizationName: "",
            organizationPhone: "",
            organizationUser: "",
            parentId: "",
            remark: "",
            id: "",
          })
        );
         this.listData = JSON.parse(JSON.stringify(this.resData));
      }
      if (this.itemAdd.id) {
        this.ruleForm.parentName = this.itemAdd.organizationName;
        this.ruleForm.parentId = this.itemAdd.id;
        this.ruleForm.organizationName = '';
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
        this.listData = JSON.parse(JSON.stringify(this.resData));
      }
       
    },
  },
  created() {},
  mounted(){
    
  },
  components: {
    TreeSelect,
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 2px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 2px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.el-button--primary {
  background: #176de6;
}
</style>